import React, { useRef } from 'react';
import "./SignupScreen.css";
import { auth, createUserWithEmailAndPassword, signInWithEmailAndPassword } from '../firebase';

function SignupScreen() {
    const emailRef = useRef(null);
    const passwordRef = useRef(null);

    const register = async (e) => {
        e.preventDefault();

        try {
            const userCredential = await createUserWithEmailAndPassword(
                auth,
                emailRef.current.value,
                passwordRef.current.value
            );

            const user = userCredential.user;
            console.log(user);
        } catch (error) {
            alert(error.message);
        }
    };

    const signIn = async (e) => {
        e.preventDefault();
        // sign-in logic

        try {
            const userCredential = await signInWithEmailAndPassword(
                auth,
                emailRef.current.value,
                passwordRef.current.value
            );

            const user = userCredential.user;
            console.log(user);
        } catch (error) {
            alert(error.message);
        }
        

    };

    return (
        <div className="signupScreen">
            <form>
                <h1>Sign In</h1>
                <input ref={emailRef} placeholder="Email" type="email"/>
                <input ref={passwordRef} placeholder="Password" type="password" />
                <button type="submit" onClick={signIn}>Sign In</button>

                <h4>
                    <span className="signupScreen_new_text">New to Us?</span>
                    <span className="signupScreen_register" onClick={register}>Let's Begin.</span>
                </h4>
            </form>
        </div>
    );
}

export default SignupScreen;
